import Vue from 'vue';
import VueI18n from 'vue-i18n';
import cnLocale from './zh';
import twLocale from './tw';
import enLocale from './en';
import _import from './_import';

Vue.use(VueI18n);

const messages = {
  //default
  en: {
      ...enLocale,
      ..._import["en"],
  },
  zh: {
      ...cnLocale,
      ..._import["zh"],
  },
  tw:{
      ...twLocale,
      ..._import["tw"],
  }
};
const i18n = new VueI18n({
  //default language
  locale: 'en',
  messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js